module.exports = __webpack_public_path__ + "img/icon-twitter.da79cc28.svg";